import styled from 'styled-components';

export const Wrapper = styled.div`
  width: auto;
  min-width: 230px;
  min-height: 220px;
  background: var(--color-surface);
  box-shadow: 0 8px 10px var(--color-shadow);
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;

  .content {
    padding: 20px 20px 60px;
  }

  .title {
    color: var(--color-text-muted);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }

  .plan-name {
    font-weight: 600;
    font-size: 36px;
    line-height: 48px;
    color: var(--color-accent);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    text-align: left;
    color: var(--color-text-muted);
    .divider {
      height: 41px;
      border-right: 1px solid var(--color-border);
      flex: 0 0 auto;
    }
  }

  h3 {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    white-space: nowrap;
  }

  .active {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    white-space: nowrap;
    padding: 8px 0 0;
  }

  .buttonContainer {
    height: 40px;
    width: calc(100% - 40px);
    margin: 0 20px;
    display: block;
    bottom: 0;
    position: absolute;
    border-top: 1px solid var(--color-border);

    button {
      border-radius: 10px;
      padding: 0;
      height: 36px;
      width: 100%;
    }
  }
`;
